import { Navigate } from "react-router-dom";

const OnboardingGuard = ({ children }) => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (role && role !== "Client" && role !== "Admin") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default OnboardingGuard;
